// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq {
  background-color: #000000;
  padding-bottom: 62px;
}

.faq__title {
  text-align: center;
  color: #FFFFFF;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
  margin-bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/home/components/faq/FAQ.scss","webpack://./src/modules/home/components/faq/FAQ.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,oBAAoB;ACCtB;;ADCE;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;ACEvB","sourcesContent":[".faq {\n  background-color: #000000;\n  padding-bottom: 62px;\n\n  &__title {\n    text-align: center;\n    color: #FFFFFF;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 40px;\n    margin-bottom: 16px;\n  }\n}",".faq {\n  background-color: #000000;\n  padding-bottom: 62px;\n}\n\n.faq__title {\n  text-align: center;\n  color: #FFFFFF;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 40px;\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
